"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPassengerTypeToString = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformPassengerTypeToString(passengerType) {
    switch (passengerType) {
        case legacy_enums_1.PassengerType.Lead:
            return "lead";
        case legacy_enums_1.PassengerType.Adult:
            return "adult";
        case legacy_enums_1.PassengerType.Child:
            return "child";
        default:
            return "unknown";
    }
}
exports.transformPassengerTypeToString = transformPassengerTypeToString;
//# sourceMappingURL=transformPassengerTypeToString.js.map